import { render, staticRenderFns } from "./LyricsScroll.vue?vue&type=template&id=7dc9bf8c&scoped=true&"
import script from "./LyricsScroll.vue?vue&type=script&lang=js&"
export * from "./LyricsScroll.vue?vue&type=script&lang=js&"
import style0 from "./LyricsScroll.vue?vue&type=style&index=0&id=7dc9bf8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dc9bf8c",
  null
  
)

export default component.exports